import { render, staticRenderFns } from "./TabStyle.vue?vue&type=template&id=7218c89e&scoped=true&"
import script from "./TabStyle.vue?vue&type=script&lang=js&"
export * from "./TabStyle.vue?vue&type=script&lang=js&"
import style0 from "./TabStyle.vue?vue&type=style&index=0&id=7218c89e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7218c89e",
  null
  
)

export default component.exports